import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGithubactionsComponent } from './simple-icons-githubactions.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGithubactionsComponent ],
    exports:      [ SimpleIconsGithubactionsComponent ],
    bootstrap:    []
})
export class SimpleIconsGithubactionsModule {}
